import { useEffect } from "react";
import { FileText, ChevronLeft, Send } from "lucide-react";
import { useToasts } from "react-toast-notifications";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";
import { useApplicationNoticePreview, useSendApplicationNotice } from "@/hooks/planning/application-order/useApplicationNotice";

import styles from "./oa-notice-preview.module.scss";

const OANoticePreview = ({ show, onHide, onBack, orderApplicationId, selectedLists, distributionListNames }) => {
	const { addToast } = useToasts();

	const { data: previewData, isLoading: isLoadingPreview, mutate: getPreview } = useApplicationNoticePreview();
	const { mutate: sendNotice, isLoading: isSending } = useSendApplicationNotice();

	useEffect(() => {
		if (show && orderApplicationId && selectedLists?.length > 0) {
			getPreview({
				orderApplicationId,
				distributionLists: selectedLists,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show, orderApplicationId, selectedLists]);

	const handleSend = () => {
		sendNotice(
			{
				orderApplicationId,
				distributionLists: selectedLists,
			},
			{
				onSuccess: () => {
					addToast("Aviso de aplicación enviado correctamente", {
						appearance: "success",
					});
					onHide();
				},
				onError: (error) => {
					addToast(error?.response?.data?.message || "Error al enviar el aviso de aplicación", {
						appearance: "error",
					});
				},
			},
		);
	};

	const getDestinationText = () => {
		return `Este aviso se enviará a ${selectedLists.length} grupo(s): ${distributionListNames}`;
	};

	return (
		<CustomModalForm
			open={show}
			onClose={onHide}
			title={
				<span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<FileText size={20} />
					Vista Previa - Aviso de Aplicación
				</span>
			}
			size="xl"
			showSave={false}
			footerLeft={
				<button className={styles.btnBack} onClick={onBack}>
					<ChevronLeft size={16} />
					Volver
				</button>
			}
			footer={
				<div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
					<button className={styles.btnCancel} onClick={onHide}>
						Cancelar
					</button>
					<button className={styles.btnSend} onClick={handleSend} disabled={isSending || isLoadingPreview}>
						<Send size={16} />
						Confirmar y Enviar
					</button>
				</div>
			}
		>
			<p className={styles.description}>
				Revise el contenido del aviso antes de enviarlo. Este documento cumple con los requisitos legales para notificación de aplicaciones agrícolas.
			</p>

			{isLoadingPreview ? (
				<CustomFetching center size="lg" />
			) : (
				<>
					<div className={styles.previewContainer} dangerouslySetInnerHTML={{ __html: previewData?.data?.html || "" }} />

					<div className={styles.destinationInfo}>
						<div className={styles.destinationTitle}>Destinatarios:</div>
						<div className={styles.destinationText}>{getDestinationText()}</div>
					</div>
				</>
			)}
		</CustomModalForm>
	);
};

export default OANoticePreview;
